/**
 * Standard content shell under DashboardHeader for HSE/KS pages.
 */
export function HsePageBody({ children, narrow = false, className = "" }) {
  return (
    <div
      className={`mx-auto mt-8 px-4 sm:px-6 lg:px-8 ${
        narrow ? "max-w-3xl" : "max-w-7xl"
      } ${className}`}
    >
      {children}
    </div>
  );
}

export function HseListCard({ children, className = "" }) {
  return (
    <div
      className={`mt-6 overflow-hidden rounded-[18px] border border-slate-200 bg-white shadow-[0_1px_2px_rgba(0,0,0,.04),0_6px_22px_rgba(0,0,0,.07)] ${className}`}
    >
      {children}
    </div>
  );
}
